import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, retry } from 'rxjs';

import { AuthService } from '../../auth.service';

Injectable({
  providedIn: 'root'
})
export const subscribeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService)
  const router: Router = inject(Router)
  const token = route.queryParams['operationId'] || route.queryParams['operation_id'] || route.queryParams['authtoken']
  // to get an authtoken from kliento: https://userv1-pp.dv-content.io/accountinfo/all?service_id=113&user_id=200316827 (userdve id, available on the back office)
  // token = 'it-8ef6504f5d1c9a8a92165888d1c7609f'

  if (token) {
    return authService.authCheckOperationId({
        operation: route.queryParams['operation_id'] || route.queryParams['operationId'],
        token: route.queryParams['authtoken'], //token
      }).pipe(
        map((res) => {
          authService.userBilled = true
          if (res.userBdd) {
            // show popup
            authService.setRegistrationAsNeeded()
            return router.parseUrl('login?user=' + res.userBdd.email)
          }
          authService.set('subtoken', res.subscription_token)
          authService.set('msisdn', res.userKliento.msisdn)
          return !!res;
        }),
        retry({ count: 15, delay: 2000 }),
        catchError(() => {
          authService.remove('subtoken')
          return of(router.parseUrl('login?operation_id=' + token + '&failure=true'))
        })
      );
  }

  return of(true)
};
